var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChurn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/profile-delete"
  }, /*#__PURE__*/React.createElement("g", {
    id: "profile-delete"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4098 18.27L15.5898 21.09",
    stroke: "#FF6363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M18.4098 21.09L15.5898 18.27",
    stroke: "#FF6363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.1586 11.0502C12.0586 11.0402 11.9386 11.0402 11.8286 11.0502C9.44859 10.9702 7.55859 9.02018 7.55859 6.62018C7.55859 4.17018 9.53859 2.18018 11.9986 2.18018C14.4486 2.18018 16.4386 4.17018 16.4386 6.62018C16.4286 9.02018 14.5386 10.9702 12.1586 11.0502Z",
    stroke: "#FF6363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M12.0008 21.9904C10.1808 21.9904 8.37078 21.5304 6.99078 20.6104C4.57078 18.9904 4.57078 16.3504 6.99078 14.7404C9.74078 12.9004 14.2508 12.9004 17.0008 14.7404",
    stroke: "#FF6363",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurn);
export default __webpack_public_path__ + "static/media/churn.c8cfa3095c90447084c549e33c6e659f.svg";
export { ForwardRef as ReactComponent };